import React from "react";
import CobrandDropDown from "../../../Checklist/Checklists/Forms/CobrandDropDown";

const CobrandsOffSettings = ({setOptionTable}) => (
    <CobrandDropDown
      name="offCobrands"
      label='Off for Cobrands'
      byNameOrId="id"
      setOptionTable={setOptionTable}
      multiSelect
    />
);

export default CobrandsOffSettings;
